<template>
  <f7-page>
    <!-- <div style="height:245px;"></div> -->
    <b-container fluid class="main-content homepageBackgroundImage icon-homepage-button-request-payment" :style="backgroundImg">
      <b-row class="showLargeScreenOnly homepageTextBloc1">
        <b-col sm="12">
          <transition name="slide-fade-title" appear>
            <div class="homepageTitle homepageTitleText">
              <img width="450px" height="22%" :src="MrBgLogo"  style="margin-left: -50px" alt="mr_logo_green" /><span class="big-title">RTP</span>
            </div>
          </transition>
        </b-col>
      </b-row>
      <b-row class="showSmallScreenOnly homepageTextBloc1">
        <b-col sm="12">
          <transition name="slide-fade-title" appear>
            <div class="homepageTitle homepageTitleText">
              <center>
              <img width="450px" height="22%" :src="MrBgLogo"  alt="mr_logo_green" />
            </center>
              <span class="big-title">Remittance</span>
            </div>
          </transition>
        </b-col>
      </b-row>
      <!-- <b-row class="homepageTextBloc2">
        <b-col sm="12">
          <transition name="slide-fade-title" appear>
            <div class="homepageBaseline homepageBaselineText d-flex">
              L'ensemble des services autour des paiements
              <br/>
              en une seule technologie
            </div>
          </transition>
        </b-col>
      </b-row> -->
      <transition name="slide-fade-title" appear>
        <b-row class="homepageCards">
          <b-col cols="2" class="d-flex flex-row" offset="4">
            <div class="homeCardBody homeCardBody-1 text-center">
              <i class="fa-light fa-arrows-rotate" style="font-size:50px"></i>
              <h4>{{ $t('Homepage.processing') }}</h4>
              <!-- <b-button class="btn" size="lg" @click="redirect('/verifications/create/')">
                {{ $t('Homepage.verify_company_do') }}
              </b-button> -->
            </div>
          </b-col>
          <b-col cols="2" class="d-flex flex-row">
            <div class="homeCardBody homeCardBody-3 text-center">
              <i class="fa-light fa-magnifying-glass" style="font-size:50px"></i>
              <h4>{{ $t('Homepage.consultations') }}</h4>
              <!-- <b-button class="btn" size="lg" @click="redirect('/suppliers/list')">
                {{ $t('Homepage.consult_seller_do') }}
              </b-button> -->
            </div>
          </b-col>
          <b-col cols="2" class="d-flex flex-row">
            <div class="homeCardBody homeCardBody-2 text-center">
              <i class="fa-light fa-download" style="font-size:50px"></i>
              <h4>{{ $t('Homepage.import_file') }}</h4>
              <!-- <b-button class="btn" size="lg" @click="redirect('/kycscores/')">
                {{ $t('Homepage.change_acceptance_do') }}
              </b-button> -->
            </div>
          </b-col>
        </b-row>
        <b-row class="homepageTextBloc3">
          <b-col sm="12">
            <transition name="slide-fade-title" appear>
              <div class="homepageSubTitle homepageSubTitleText">
                <img class="homepageSubTitleLogo" :src="imgLogo"/>
              </div>
            </transition>
          </b-col>
        </b-row>
      </transition>
    </b-container>
  </f7-page>
</template>

<script>
import homepageGridLine from '@/components/Homepage/homepageGridLine.vue'
import buttonsData from '@/pages/user/data/homepageData.json'
import Img from '../../assets/static/images/homepage/accueil.jpg'
import Logo from './../../assets/static/images/StreamMind_horizontal.png'
import {loadPage} from '@/helpers/routing'
import MoneyRoadLogo from '../../assets/static/images/homepage/moneyroad_texte_seul.png'

export default {
  name: 'Homepage',
  components: {
    'homepage-grid-line': homepageGridLine
  },
  props: {
    context: {
      default: 'generic',
      type: String
    }
  },
  data () {
    return {
      data: buttonsData.buttons,
      backgroundImg: 'background-image: url(' + Img +')',
      imgLogo: Logo,
      MrBgLogo: MoneyRoadLogo
    }
  },
  created () {
    this.$bus.emit('isOnHomepage', true)
    this.$$('.homepageNavbar').removeClass('deleteNavBar')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: '',
      navTitle: '',
      returnUrl: ''
    })
  },
  methods: {
    redirect (url) {
      loadPage(this, { url: url })
    }
  }
}
</script>
<style scoped>
/* .card, .card-body .card-title {
  background: var(--actionButtonColorViolet);
  color: var(--actionTextColorWhite)!important;
  min-height: 300px;
} */
.homepageCards {
  position: fixed;
  top: calc(50% - 50px);
  width: 68%;
}

.homeCardBody {
  color: var(--actionTextColorWhite)!important;
  min-height: 300px;
  min-width: 270px;
  width: 270px;
  height: 300px;
  border-radius: var(--borderRadius);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content:space-around;
}

.homeCardBody h4{
  color: var(--actionTextColorWhite)!important;
}

.homeCardBody.homeCardBody-1 {
  background: linear-gradient(0.25turn,#3b39ce,var(--actionButtonColorViolet));
}

.homeCardBody.homeCardBody-2 {
  background: linear-gradient(0.25turn,#fed709,#ffac3e)
}

.homeCardBody.homeCardBody-3 {
  background: linear-gradient(0.25turn,var(--actionButtonColorBlue),#225cd5)
}

.main-content {
  height: 100%;
  overflow-x: hidden;
}
.main-page-positionning {
  margin-top: 44px;
  margin-bottom: 44px;
}
.homepageBackgroundImage {
  background-size: cover;
}
.homepageBaseline {
  display: block !important;
  text-align: center;
  top: 10%;
}
.homepageBaselineText {
  margin-top: 2%;
  font-weight: bolder;
  font-size: 1.2rem;
  line-height: normal;
  color: #ffffff;
}
.homepageSubTitle {
  display: block !important;
  text-align: center;
  top: 10%;
}
.homepageSubTitleText {
  margin-top: 2%;
  font-weight: bolder;
  font-size: 2rem;
  line-height: normal;
  color: #ffffff;
}
.homepageTitle {
  display: block !important;
  text-align: center;
  top: 10%;
  height: 500px;
}
.homepageTitleText {
  margin-top: 2%;
  font-size: 3rem;
  line-height: normal;
}

@media (min-width:630px) and (max-width:889px) {
  .homepageBaselineText {
    font-size: 1.5rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 4rem;
  }
}
@media (min-width:890px) and (max-width:991px) {
  .homepageBaselineText {
    font-size: 2rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 5rem;
  }
}

@media (min-width:992px) and (max-width:1199px) {
  .homepageBaselineText {
    font-size: 2rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 6rem;
  }
}

@media (min-width:1030px) and (max-width:1199px) {
  .homepageBaselineText {
    font-size: 2rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 7rem;
  }
}
@media (min-width:1200px) {
  .homepageBaselineText {
    font-size: 2.5rem;
  }
  .homepageSubTitleText {
    font-size: 2.5rem;
  }
  .homepageTitleText {
    font-size: 8rem;
  }
}

@media (min-width:992px) {
  .main-page-positionning {
    margin-top: 100px;
    margin-bottom: 100px;
  }
}

.homepageTextBloc1 {
  position: fixed;
  margin-top: -100px;
  top: calc(27% - 50px);
  width: 100%;
}

.homepageTextBloc2 {
  position: fixed;
  height: 200px;
  margin-top: -40px;
  top: 20%;
  width: 100%;
}

.homepageTextBloc3 {
  position: fixed;
  height: 200px;
  margin-top: -180px;
  top: calc(93% + 100px);
  width: 100%;
}

@media (max-width:991px) {
  .homepageTextBloc1 {
    /* top: calc(50% + 44px); */
  }
  .homepageTextBloc2 {
    top: calc(20% + 44px);
  }
  .homepageTextBloc3 {
    top: calc(80% + 44px);
  }
  .main-content {
    height: calc(100% - 44px);
  }
}

.homepageSubTitleLogo {
  width: 200px;
  margin-right: 1rem;
}

@media (max-width:450px) {
  .homepageSubTitleLogo {
    width: 350px;
  }
}

/* .icon-homepage-button-request-payment {
  background-image: url('./../../assets/static/images/homepage/accueil.png');
} */
</style>
